import { useOnClickOutside } from './use-on-click-outside';
export default useOnClickOutside;
